import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownProps = {
  size?: 'lg' | 'sm';
  tone?: 'light' | 'dark';
};
export function Countdown({
  size = 'lg'
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'hrs'
  }, {
    value: minutes,
    label: 'min'
  }, {
    value: seconds,
    label: 'sec'
  }];
  const isLarge = size === 'lg';
  return <div className="flex items-center justify-center gap-2 sm:gap-3" role="timer" aria-live="off" aria-label={`Offer ends in ${hours} hours ${minutes} minutes ${seconds} seconds`} data-id="element-80" data-mp="3c131949yu1l7">
      {units.map(unit => <div key={unit.label} className={`rounded-2xl bg-white text-center tabular-nums text-navy shadow-card ${isLarge ? 'min-w-[74px] px-4 py-3 sm:min-w-[92px] sm:px-6 sm:py-4' : 'min-w-[58px] px-3 py-2'}`} data-id="element-81" data-mp="3262p844m41d4">
          <div className={`font-display font-semibold leading-none ${isLarge ? 'text-3xl sm:text-5xl' : 'text-2xl'}`} data-id="element-82" data-mp="15a4vfz99pb9s">
            {unit.value}
          </div>
          <div className={`mt-1 font-semibold text-navy-muted ${isLarge ? 'text-[11px]' : 'text-[10px]'}`} data-id="element-83" data-mp="t2d9dn6ceot6">{unit.label}</div>
        </div>)}
    </div>;
}